export const API_URL = 'https://yxz29hjke6.execute-api.us-east-1.amazonaws.com/prod';
export const GOOGLE_CLIENT_ID = '339192823061-e5ki1scaq3dj002kb5o6hhnvqto6r6cr.apps.googleusercontent.com';
